import React from 'react';
import { HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../styles/theme/foundation/colors';

function NonbooleanPolicyProperties({ propertyName, propertyValue, isArchived }) {
  return (
    <HStack mb={2}>
      <Text color={colors.greyScale['500']} textAlign="right" textStyle="bodyXs" w="60%">
        {propertyName}
      </Text>
      <Text color={isArchived ? colors.greyScale['800'] : colors.greyScale['900']} textStyle="bodySm500" w="40%">
        {propertyValue}
      </Text>
    </HStack>
  );
}

NonbooleanPolicyProperties.propTypes = {
  propertyName: PropTypes.string,
  propertyValue: PropTypes.string,
  isArchived: PropTypes.bool
};

export default NonbooleanPolicyProperties;
